// import React from "react";
// import colors from "../../config/colors";
// import { ButtonSpacer } from "../Button/styles";
// import Icon from "../Icon";
// import {
//   TableContainer,
//   TableHead,
//   TableHeaderCell,
//   TableBody,
//   TableRow,
//   TableCell,
//   TableHeaderCellContent,
//   LoaderContainer,
// } from "./styles";
// import Checkbox from "../Checkbox";
// import Loading from "../Loading";

// /**
//  *
//  * The classic table component.
//  * Takes in columns and rows and renders them as a table.
//  */
// function Table({
//   columns,
//   rows,
//   sortTimeSheet,
//   meetingsDashboard,
//   meetings,
//   isHeightInherited,
//   width,
//   minWidth,
//   loader = false,
//   isApplicants,
//   isActive,
//   selectAllHandler,
//   allChecked,
// }) {
//   const [sortOptions, setSortOptions] = React.useState({
//     column: null,
//     direction: null,
//   });
//   function sortOnColumn(column) {
//     if (column === sortOptions.column && !sortTimeSheet) {
//       setSortOptions({
//         ...sortOptions,
//         direction: sortOptions.direction === "asc" ? "desc" : "asc",
//       });
//     } else {
//       setSortOptions({
//         ...sortOptions,
//         column: column,
//         direction: !sortTimeSheet ? "asc" : "desc",
//       });
//     }
//   }

//   React.useEffect(() => {
//     if (sortTimeSheet) {
//       sortOnColumn(columns[0].key);
//     }
//   }, []);

//   return (
//     <TableContainer
//       minWidth={minWidth}
//       meetingsDashboard={meetingsDashboard}
//       isApplicants={isApplicants}
//     >
//       <TableHead
//         meetingsDashboard={meetingsDashboard}
//         isApplicants={isApplicants}
//       >
//         {columns.map((column) => (
//           <TableHeaderCell
//             isActive={isActive}
//             meetingsDashboard={meetingsDashboard}
//             isApplicants={isApplicants}
//             key={"header_" + column.key}
//             onClick={() => {
//               if (column.sortable !== false) {
//                 sortOnColumn(column.key);
//               }
//             }}
//           >
//             <TableHeaderCellContent
//               isActive={isActive}
//               meetingsDashboard={meetingsDashboard}
//               isApplicants={isApplicants}
//               space={column.checkbox}
//             >
//               {column.checkbox && (
//                 <Checkbox
//                   value={allChecked}
//                   setValue={(event) => selectAllHandler(event)}
//                 />
//               )}

//               {column.title}

//               {sortOptions.column === column.key && (
//                 <>
//                   <ButtonSpacer />
//                   {sortOptions.direction === "asc" ? (
//                     <Icon type={"collapse"} color={colors.text} size="10" />
//                   ) : (
//                     <Icon type={"expand"} color={colors.text} size="10" />
//                   )}
//                 </>
//               )}
//             </TableHeaderCellContent>
//           </TableHeaderCell>
//         ))}
//       </TableHead>
//       <TableBody isHeightInherited={isHeightInherited} loader={loader}>
//         {loader ? (
//           <LoaderContainer>
//             <Loading />
//           </LoaderContainer>
//         ) : (
//           rows
//             ?.sort((a, b) => {
//               if (sortOptions.column === null) {
//                 return 0;
//               } else {
//                 let valueA = a[sortOptions.column] || "";
//                 let valueB = b[sortOptions.column] || "";
//                 return (
//                   (sortOptions.direction === "asc" ? 1 : -1) *
//                   valueA.toString().localeCompare(valueB.toString())
//                 );
//               }
//             })
//             ?.map((row, index) => (
//               <TableRow key={"row_" + index}>
//                 {columns.map((column) => (
//                   <TableCell
//                     isActive={isActive}
//                     width={column?.width}
//                     meetings={meetings}
//                     key={"cell_" + column.key + "_" + index}
//                     meetingsDashboard={meetingsDashboard}
//                     isApplicants={isApplicants}
//                   >
//                     {column.render ? (
//                       <column.render
//                         value={row[column.key]}
//                         row={row}
//                         index={index}
//                       >
//                         {row[column.key]}
//                       </column.render>
//                     ) : (
//                       row[column.key]
//                     )}
//                   </TableCell>
//                 ))}
//               </TableRow>
//             ))
//         )}
//       </TableBody>
//     </TableContainer>
//   );
// }
// export default Table;

import React from "react";
import colors from "../../config/colors";
import { ButtonSpacer } from "../Button/styles";
import Icon from "../Icon";
import {
  TableContainer,
  TableHead,
  TableHeaderCell,
  TableBody,
  TableRow,
  TableCell,
  TableHeaderCellContent,
  LoaderContainer,
} from "./styles";
import Checkbox from "../Checkbox";
import Loading from "../Loading";

/**
 * The classic table component.
 * Takes in columns and rows and renders them as a table.
 */
function Table({
  columns,
  rows,
  sortTimeSheet,
  meetingsDashboard,
  meetings,
  isHeightInherited,
  width,
  minWidth,
  loader = false,
  isApplicants,
  isActive,
  selectAllHandler,
  allChecked,
}) {
  const [sortOptions, setSortOptions] = React.useState({
    column: null,
    direction: null,
  });

  function sortOnColumn(column) {
    if (column === sortOptions.column && !sortTimeSheet) {
      setSortOptions({
        ...sortOptions,
        direction: sortOptions.direction === "asc" ? "desc" : "asc",
      });
    } else {
      setSortOptions({
        ...sortOptions,
        column: column,
        direction: !sortTimeSheet ? "asc" : "desc",
      });
    }
  }

  React.useEffect(() => {
    if (sortTimeSheet) {
      sortOnColumn(columns[0].key);
    }
  }, []);

  function getComparableValue(value) {
    if (typeof value === "object" && value?.name) {
      return value.name;
    }
    return value;
  }

  function getValue(obj, path) {
    return path.split(".").reduce((acc, part) => acc && acc[part], obj);
  }


  return (
    <TableContainer
      minWidth={minWidth}
      meetingsDashboard={meetingsDashboard}
      isApplicants={isApplicants}
    >
      <TableHead
        meetingsDashboard={meetingsDashboard}
        isApplicants={isApplicants}
      >
        {columns.map((column) => (
          <TableHeaderCell
            isActive={isActive}
            meetingsDashboard={meetingsDashboard}
            isApplicants={isApplicants}
            key={"header_" + column.key}
            onClick={() => {
              if (column.sortable !== false) {
                sortOnColumn(column.key);
              }
            }}
          >
            <TableHeaderCellContent
              isActive={isActive}
              meetingsDashboard={meetingsDashboard}
              isApplicants={isApplicants}
              space={column.checkbox}
            >
              {column.checkbox && (
                <Checkbox
                  value={allChecked}
                  setValue={(event) => selectAllHandler(event)}
                />
              )}

              {column.title}

              {sortOptions.column === column.key && (
                <>
                  <ButtonSpacer />
                  {sortOptions.direction === "asc" ? (
                    <Icon type={"collapse"} color={colors.text} size="10" />
                  ) : (
                    <Icon type={"expand"} color={colors.text} size="10" />
                  )}
                </>
              )}
            </TableHeaderCellContent>
          </TableHeaderCell>
        ))}
      </TableHead>
      <TableBody isHeightInherited={isHeightInherited} loader={loader}>
        {loader ? (
          <LoaderContainer>
            <Loading />
          </LoaderContainer>
        ) : (
          rows
          ?.sort((a, b) => {
              if (!sortOptions.column) return 0;

              const columnDef = columns.find(
                (col) => col.key === sortOptions.column
              );
              const getSortValue =
                columnDef && typeof columnDef.sortValueFn === "function"
                  ? columnDef.sortValueFn
                  : (row) => getValue(row, sortOptions.column); // Safe fallback

              const valueA = getSortValue(a);
              const valueB = getSortValue(b);
              const direction = sortOptions.direction === "asc" ? 1 : -1;

              if (valueA == null && valueB == null) return 0;
              if (valueA == null) return 1;
              if (valueB == null) return -1;

              if (!isNaN(valueA) && !isNaN(valueB)) {
                return direction * (Number(valueA) - Number(valueB));
              }

              if (!isNaN(Date.parse(valueA)) && !isNaN(Date.parse(valueB))) {
                return direction * (new Date(valueA) - new Date(valueB));
              }

              return (
                direction * valueA.toString().localeCompare(valueB.toString())
              );
            })
            ?.map((row, index) => (
              <TableRow key={"row_" + index}>
                {columns.map((column) => (
                  <TableCell
                    isActive={isActive}
                    width={column?.width}
                    meetings={meetings}
                    key={"cell_" + column.key + "_" + index}
                    meetingsDashboard={meetingsDashboard}
                    isApplicants={isApplicants}
                  >
                    {column.render ? (
                      <column.render
                        value={row[column.key]}
                        row={row}
                        index={index}
                      >
                        {row[column.key]}
                      </column.render>
                    ) : (
                      row[column.key]
                    )}
                  </TableCell>
                ))}
              </TableRow>
            ))
        )}
      </TableBody>
    </TableContainer>
  );
}

export default Table;
